import { Component, OnInit, Input } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { DragDropModule } from 'primeng/dragdrop';
import {
  AlertService,
  AuthenticationService,
  ClientProfileService,
  FileBlobService,
  ProjectControlItemService,
  TenantService,
  UserService,
} from '../../_services/index';

import { DictionaryItem } from "../../_models/dictionaryItem";
import { LoginHelper, Role } from "../../helpers";
import { DictionaryService } from '../../_services/dictionary.service';
@Component({
  standalone: false,
  selector: 'rizkListConfig-component',
  templateUrl: './rizkListConfig.component.html',
  styleUrls: ['./rizkListConfig.component.scss'],
})
export class RizkListConfigComponent implements OnInit {
  @Input() mode: 'organizations' | 'scoring' | 'both' = 'both';

  businessUnits: string[] = [];
  scoring: string[] = [];
  businessUnitsId?: number;
  scoringId?: number;


  draggedIndex: number | null = null;
  draggedList: 'business' | 'scoring' | null = null;


  constructor(
    public dictionaryService : DictionaryService,
    public userService: UserService,
    public authenticationService: AuthenticationService,
  ) { }

  ngOnInit(): void {
    this.dictionaryService.get(['BusinessUnits', 'Scoring']).subscribe((r) => {
      const buRow = r.find((d) => d.dictionary === 'BusinessUnits');
      console.log("buRow", buRow);
      this.businessUnits = buRow?.businessUnits?.length
        ? [...buRow.businessUnits]
        : ['Finance', 'HR', 'Customer Support'];
      this.businessUnitsId = buRow?.itemId;

      const scoringRow = r.find((d) => d.dictionary === 'Scoring');
      this.scoring = scoringRow?.scoring?.length
        ? [...scoringRow.scoring]
        : Array.from({ length: 10 }, (_, i) => (i + 1).toString());
      this.scoringId = scoringRow?.itemId;
      console.log("business units id", this.businessUnitsId);
    });
  }



  addItem(list: 'business' | 'scoring'): void {
    if (list === 'business') {
      this.businessUnits.push('');
    } else {
      this.scoring.push('');
    }
  }

  removeItem(list: 'business' | 'scoring', index: number): void {
    if (list === 'business') {
      this.businessUnits.splice(index, 1);
    } else {
      this.scoring.splice(index, 1);
    }
  }


  onDragStart(index: number, list: 'business' | 'scoring'): void {
    this.draggedIndex = index;
    this.draggedList = list;
  }

  onDrop(dropIndex: number, list: 'business' | 'scoring'): void {
    if (this.draggedIndex === null || this.draggedList !== list) return;

    const targetList = list === 'business' ? this.businessUnits : this.scoring;
    const [item] = targetList.splice(this.draggedIndex, 1);
    targetList.splice(dropIndex, 0, item);

    this.draggedIndex = null;
    this.draggedList = null;
  }
  onSave(): void {
    const tenantName = LoginHelper.getTenantName();
    if (!tenantName || !LoginHelper.getUserToken()) {
      this.authenticationService.logout();
      return;
    }

    //console.log("business units id", this.businessUnitsId);
    //console.log("scoring id", this.scoringId);
    const buPayload: DictionaryItem = {
      itemId: this.businessUnitsId,
      dictionary: 'BusinessUnits',
      businessUnits: [...this.businessUnits],
    };

    const scoringPayload: DictionaryItem = {
      itemId: this.scoringId,
      dictionary: 'Scoring',
      scoring: [...this.scoring],
    };
    this.dictionaryService.save(buPayload).subscribe({
      next: (res) => {
        console.log('BusinessUnits updated:', res);
        this.businessUnitsId = res.itemId;
      },
      error: (err) => console.error('Error updating BusinessUnits:', err),
    });

    this.dictionaryService.save(scoringPayload).subscribe({
      next: (res) => {
        console.log('Scoring updated:', res);
        this.scoringId = res.itemId;
      },
      error: (err) => console.error('Error updating Scoring:', err),
    });
  }

  trackByIndex(index: number, item: any) {
    return index;
  }
}
